import { Skeleton } from 'ui/components/primitives';
import { PRODUCT_CARD_CONST } from './ProductCard.d';
import { SkeletonCard } from './ProductCard.styles';

const SkeletonCardBase = () => (
  <SkeletonCard.Card data-radius="rounded" data-testid={PRODUCT_CARD_CONST.TEST_ID} spacing="small">
    <SkeletonCard.Image>
      <Skeleton />
    </SkeletonCard.Image>

    <SkeletonCard.Code>
      <Skeleton />
    </SkeletonCard.Code>

    <SkeletonCard.Title>
      <Skeleton />
    </SkeletonCard.Title>

    <SkeletonCard.Tags>
      <SkeletonCard.Tag>
        <Skeleton />
      </SkeletonCard.Tag>

      <SkeletonCard.Tag>
        <Skeleton />
      </SkeletonCard.Tag>
    </SkeletonCard.Tags>

    <SkeletonCard.PriceWrapper>
      <Skeleton />
    </SkeletonCard.PriceWrapper>

    <SkeletonCard.PriceWrapper>
      <Skeleton />
    </SkeletonCard.PriceWrapper>

    <SkeletonCard.PriceWrapper>
      <Skeleton />
    </SkeletonCard.PriceWrapper>

    <SkeletonCard.Button>
      <Skeleton />
    </SkeletonCard.Button>
  </SkeletonCard.Card>
);

export default SkeletonCardBase;
